/** Textes « amendes » — le français fait foi. */
export const amendes = {
  erreur: 'Erreur',
  titre: 'Amendes',
  sousTitre: 'Rattachees automatiquement au conducteur de la date — article 07',
  enregistrer: 'Enregistrer une amende',
  rattachee: (n: string) => `Rattachee a ${n}`,
  aucuneLocation: 'Aucune location à cette date',
  retrouve: (nom: string) => `Le conducteur du jour a ete retrouve : ${nom}. L'amende est marquee « a refacturer ».`,
  chargeAgence: "Aucun client ne conduisait ce véhicule à cette date : l'amende reste à la charge de l'agence.",
  aRefacturer: (m: string) => `${m} a refacturer a vos clients`,
  aRefacturerTexte: (n: number) => `${n} amende(s) rattachee(s) a une location, pas encore repercutee(s).`,
  aucune: 'Aucune amende enregistrée',
  col: { infraction: 'Infraction', vehicule: 'Véhicule', conducteur: 'Conducteur retrouve', pv: 'N° PV', montant: 'Montant', statut: 'Statut' },
  chargeAgenceCourt: "a la charge de l'agence",
  statuts: { a_refacturer: 'a refacturer', refacturee: 'refacturee' } as Record<string, string>,
  aide: "Saisissez la date de l'infraction, pas celle de réception : c'est elle qui permet de retrouver le conducteur.",
  vehicule: 'Véhicule',
  choisir: 'Choisir…',
  date: "Date de l'infraction",
  montant: (d: string) => `Montant (${d})`,
  pv: 'N° du procès-verbal',
  description: 'Description',
  descriptionExemple: 'Excès de vitesse — RN5',
  annuler: 'Annuler',
  rattacher: 'Enregistrer et rattacher',
};
